import React, { useEffect, useState, useCallback } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { Input } from 'Components/Input'
import Button from '@mui/material/Button'
import ComboBox from 'Components/ComboBox'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: 2,
  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function EditOperation({
  setOperations,
  setSelected,
  params,
  operations,
  category,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [selectedCategory, setSelectedCategory] = useState({})
  const [selectedPriorite, setSelectedPriorite] = useState({})

  const handleModelClose = () => {
    setSelected(false)
    reset()
  }
  const priorite = [
    { label: 'Important et urgent', id: 1 },
    { label: 'Important et non urgent', id: 2 },
    { label: 'Non-important et urgent', id: 3 },
    { label: 'Non-important et non-urgent', id: 4 },
  ]
  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      Nom: params.Name,
      Descriptions: params.Description,
      DateLimite: params.Date_limite,
      Priorite: priorite.find((el) => el.label === params.Urgence),
      Categorie: category.find((el) => el.id === params.cat_id),
      Couts: params.Cost_estime,
    },
  })

  useEffect(() => {
    setSelectedPriorite(getValues('Priorite'))
    setSelectedCategory(getValues('Categorie'))
  }, [])

  const onSubmit = async (data) => {
    let id = params.id
    const filteredOperations = operations.results.filter((v) => v.id !== id)
    const updatedOperations = [
      ...filteredOperations,
      {
        id: id,
        Name: data.Nom,
        Description: data.Descriptions,
        Cost_estime: data.Couts,
        Urgence: data.Priorite.label,
        cat_id: data.Categorie.id,
        Date_limite: data.DateLimite,
      },
    ].sort((a, b) => (a.id > b.id ? 1 : -1))

    setOperations((operations) => ({
      ...operations,
      results: updatedOperations,
    }))

    handleModelClose()
  }

  return (
    <>
      <Modal
        open={true}
        onClose={handleModelClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: 'scroll', '.tachmo': { width: isMobile ? '90%' : '500px' } }}
      >
        <Box className="tachmo" sx={mstyle}>
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    {t('mesToDo.newTask')}
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'text',
                        }}
                        rules={{ required: true }}
                        name="Nom"
                        label="Nom"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: false,
                          size: 'small',
                          type: 'text',
                        }}
                        rows={4}
                        multiline
                        rules={{ required: true }}
                        name="Descriptions"
                        label={t('mesToDo.description')}
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'date',
                        }}
                        rules={{ required: true }}
                        name="DateLimite"
                        label={t('mesToDo.fieldDueDate')}
                        InputLabelProps={{ shrink: true }}
                      />

                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Priorite', j)
                          setSelectedPriorite(j)
                        }}
                        label="Priorite"
                        data={priorite}
                        name="Priorite"
                        required={true}
                        selectedValue={selectedPriorite}
                      />
                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Categorie', j)
                          setSelectedCategory(j)
                        }}
                        label={t('mesToDo.fieldCategory')}
                        data={category}
                        name="Categorie"
                        required={true}
                        selectedValue={selectedCategory}
                      />

                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          required: true,
                          size: 'small',
                          type: 'number',
                        }}
                        rules={{ required: true }}
                        name="Couts"
                        label={t('mesToDo.fieldCosts')}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button sx={{ marginLeft: 'auto !important' }} type="submit">
                        {t('mesToDo.validate')}
                      </Button>
                      <Button onClick={handleModelClose}>{t('mesToDo.cancel')}</Button>
                    </DialogActions>
                  </form>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
